export default {"src":"/_next/static/media/how-it-works-2.7e8c4ea5.svg","height":226,"width":314,"blurWidth":0,"blurHeight":0};